import React from 'react';
import { useDispatch } from 'react-redux';
import SearchSelectUsers from 'components/inputs/searchSelectUsers';
import { Icon, Message, Checkbox, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { convertToLocalMoment } from 'businessLogic/datetime';
import HtmlToReact from 'html-to-react';
import xss from 'xss';
import moment from 'moment';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function CenterPanel(props) {
  const dispatch = useDispatch();

  const formatAlreadyInvitedMessage = (message, selectedUser, userLastInvited) => {
    if (selectedUser.isEmailOnlyUser) {
      message = message.replace(/##person##/g, selectedUser.email);
    } else {
      message = message.replace(/##person##/g, selectedUser.firstName + ' ' + selectedUser.lastName);
    }
    let inviteExpiringOn = convertToLocalMoment(moment(userLastInvited.expriyTime), props.timezone);
    let inviteExpiringOnFormatted = inviteExpiringOn.format(APP.LANGUAGE.WaitingAreaSelfProvision.DateTimeFormat);
    inviteExpiringOnFormatted = inviteExpiringOnFormatted.replace(/ /g, '&nbsp;');
    message = message.replace(/##Time##/g, inviteExpiringOnFormatted);

    return message;
  };

  let warningClass = 'borderless bg-transparent pdlnull pdrnull color-warning top-with-flex';
  let warningContent = (
    <div>
      <div className="mrbxl pdbxl hide-on-small-ress " /> <div className="mrbxl pdbxl hide-on-small-ress " />{' '}
    </div>
  );
  if (props.hasUserValidInvitation && props.selectedUsers.length > 0 && props.userLastInvited.email) {
    const alreadyInvitedMessage = formatAlreadyInvitedMessage(
      APP.LANGUAGE.WaitingAreaSelfProvision.UserAlreadyInvite,
      props.selectedUsers[0],
      props.userLastInvited
    );
    warningContent = (
      <div id="alreadyInvited">
        <Message icon className={warningClass}>
          <Icon name="exclamation circle" className="mrrs" />
          <Message.Content>
            <div className="color-info">
              <span>
                <div>{htmlToReactParser.parse(xss(alreadyInvitedMessage))}</div>
                <div className="pdts pdbxs">{APP.LANGUAGE.WaitingAreaSelfProvision.UserAlreadyInvitePartTwo}</div>
              </span>
            </div>
          </Message.Content>
        </Message>
      </div>
    );
  }
  return (
    <span>
      <div className="ui form ">
        <div className="pdts">
          <SearchSelectUsers
            allowNewInvite={true}
            allowMultipleUserSelection={false}
            dispatch={dispatch}
            notClearSearchAfterSelection={true}
            searchFieldLabel={APP.LANGUAGE.WaitingAreaSelfProvision.InviteLabel}
            userSelectedCallBack={props.userSelectedCallBack}
          />
        </div>
        <Container fluid as={Media} greaterThanOrEqual="computer" className="center-flex display-flex mrtm">
          <Checkbox className="ui checkbox mrrs" onChange={props.checkBoxOnChange} checked={props.ifCheckboxChecked} />
          <span>{htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaSelfProvision.CheckboxText1))}</span>
        </Container>
        <Container fluid as={Media} lessThan="computer" className="center-flex display-flex mrtm">
          <Checkbox className="ui checkbox mrrxl" onChange={props.checkBoxOnChange} checked={props.ifCheckboxChecked} />
          <span>{htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaSelfProvision.CheckboxText1))}</span>
        </Container>
        <Container
          fluid
          as={Media}
          greaterThanOrEqual="computer"
          style={{ marginLeft: '31px', maxWidth: '95%' }}
          className="mrtxs"
        >
          {htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaSelfProvision.CheckboxText2))}
        </Container>
        <Container as={Media} lessThan="computer" className="mrtxs">
          {htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaSelfProvision.CheckboxText2))}
        </Container>
        {warningContent}
        <div className="mrbxl pdbl hide-on-small-ress " />
        <div className="mrbxl pdbm hide-on-small-ress " />
      </div>
    </span>
  );
}
